'use client';
import { motion } from 'motion/react';
import Link from 'next/link';
import { Logo } from '~/components';
import { MenuLink } from '~/menu/components';

export const Header = ({ isSignedIn }: { isSignedIn: boolean }) => {
  return (
    <header>
      <Link
        className="fixed left-6 top-6 z-[100] md:left-6 md:top-10 lg:left-16 lg:top-16"
        href="/"
      >
        <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
          <Logo />
        </motion.div>
      </Link>

      {/* {isSignedIn && (
        <div className="fixed right-20 top-4 z-40 ml-auto flex h-16 items-center gap-10 md:right-24 md:top-9 lg:right-28 lg:top-[3.25rem]">
          <AvatarLink
            className="motion-opacity-in-0 hidden lg:block"
            href={getDashboardFirstLink().href}
          />
        </div>
      )} */}

      <MenuLink />
    </header>
  );
};
